import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '@nrwl/environment';
import { AuthService, isPresignedStorageUrl } from '@nrwl/rx-service-auth';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DoctorTokenInterceptor implements HttpInterceptor {
  env = environment;
  private authService: AuthService | null = null;

  constructor(private injector: Injector) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('x-skip-interceptor')) {
      return next.handle(req);
    }

    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }

    let authToken = this.authService.getSchedulerToken();

    if (authToken && !isPresignedStorageUrl(req.url)) {
      const headers = {};
      headers['Authorization'] = `Token ${authToken}`;
      if (!req.headers.has('Accept')) {
        headers['Accept'] = `application/json`;
      }
      req = req.clone({ setHeaders: headers });
    }

    return next.handle(req).pipe(
      catchError((error: any) => {
        return this.errorHandler(error.status, error);
      }),
    );
  }

  private errorHandler(status, response: HttpEvent<any>): Observable<HttpEvent<any>> {
    switch (status) {
      case 401:
        {
          try {
            (window as any).webkit.messageHandlers.rxEventLogout.postMessage({ flag: true });
          } catch (e) {}
        }
        break;
    }
    throw response;
  }
}
